


import React from 'react';
import './style.css';

const LoadingButton = ({ onClick, children, className, loading ,hideButton , disabled}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled} // Ensure the button is disabled when `disabled` or `loading` is true
      className={`relative inline-flex items-center justify-center  px-4 py-2 rounded-md ${className}`}
      
    >
      <span className={`absolute inset-0 flex items-center justify-center ${loading ? 'block' : 'hidden'}`}>
        <div className="flex space-x-1">
          <div className={`dot ${hideButton ? 'bg-gray-600' : 'bg-white'} w-2.5 h-2.5 rounded-full`}></div>
          <div className={`dot ${hideButton ? 'bg-gray-600' : 'bg-white'} w-2.5 h-2.5 rounded-full`}></div>
          <div className={`dot ${hideButton ? 'bg-gray-600' : 'bg-white'} w-2.5 h-2.5 rounded-full`}></div>
          <div className={`dot ${hideButton ? 'bg-gray-600' : 'bg-white'} w-2.5 h-2.5 rounded-full`}></div>
        </div>
      </span>
      {!hideButton && <span className={`${loading ? 'opacity-0' : 'opacity-100'} transition-opacity`}>
        {children}
      </span>}
      
    </button>
  );
};

export default LoadingButton;



